import { DesignCard } from './DesignCard';
import type { DesignCardData } from './DesignCard';

interface DesignCardsProps {
  designs: DesignCardData[];
}

/**
 * Renders 1-3 AI-generated design cards in a vertical stack inside the OptiBot chat bubble.
 */
export function DesignCards({ designs }: DesignCardsProps) {
  if (designs.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-2">
      {designs.map((design) => (
        <DesignCard key={design.designId} {...design} />
      ))}
    </div>
  );
}
